exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-pagination{position:absolute;bottom:0}.VueCarousel-navigation-button.VueCarousel-navigation-prev{left:35px}.VueCarousel-navigation-button.VueCarousel-navigation-next{right:35px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f9f93f4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./web/app/themes/giles/resources/js/components/LaserSlider.vue
// module id = 409
// module chunks = 0